import { Box, Button, Flex, HStack, Icon, Text } from '@chakra-ui/react'
import { FC } from 'react'
import { RiLinkUnlink } from 'react-icons/ri'

const TelaExpirado: FC = () => (
  <Flex
    direction="column"
    align="center"
    justify="center"
    minH="calc(100vh - 64px)"
    bg="#f8fafc"
    px={4}
  >
    <Box
      bg="white"
      borderRadius="2xl"
      p={6}
      mb={8}
      boxShadow="sm"
      border="1px solid"
      borderColor="gray.100"
    >
      <Icon as={RiLinkUnlink} boxSize={10} color="#0f5238" />
    </Box>

    <Text
      fontSize={{ base: '26px', md: '32px' }}
      fontWeight="800"
      color="gray.900"
      mb={3}
      textAlign="center"
    >
      O link não é mais válido
    </Text>
    <Text
      fontSize="15px"
      color="gray.500"
      maxW="420px"
      textAlign="center"
      mb={8}
      lineHeight="1.7"
    >
      Este acesso expirou ou foi removido por segurança. Links de convite são
      temporários e duram 7 dias.
    </Text>

    <HStack spacing={3} mb={10}>
      <Button
        bg="#0f5238"
        color="white"
        borderRadius="md"
        px={7}
        py={6}
        fontWeight="700"
        fontSize="13px"
        letterSpacing="0.5px"
        _hover={{ bg: '#1d5840' }}
        textTransform="uppercase"
      >
        Voltar ao Início
      </Button>
      <Button
        variant="outline"
        borderColor="gray.300"
        color="gray.700"
        borderRadius="md"
        px={7}
        py={6}
        fontWeight="700"
        fontSize="13px"
        letterSpacing="0.5px"
        _hover={{ bg: 'gray.50' }}
        textTransform="uppercase"
      >
        Falar com Suporte
      </Button>
    </HStack>

    <Box
      bg="gray.100"
      borderRadius="full"
      px={5}
      py={2}
      display="flex"
      alignItems="center"
      gap={2}
    >
      <Box
        w="16px"
        h="16px"
        borderRadius="full"
        border="2px solid"
        borderColor="gray.400"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Box w="6px" h="6px" borderRadius="full" bg="gray.400" />
      </Box>
      <Text fontSize="13px" color="gray.500" fontWeight="500">
        Proteção de Dados Leo Madeiras
      </Text>
    </Box>
  </Flex>
)

export default TelaExpirado
